import { Play, Youtube, Clock } from "lucide-react";
import { Reveal, SectionHeader } from "./SectionHeader";

const VIDEO_URL = "https://www.youtube.com/watch?v=i4ceFizLb-0";

const POINTS = [
  "Qué es la lectura fácil y por qué es una herramienta real de inclusión.",
  "Cómo validan los textos las personas del CAI de Pando, en Langreo.",
  "Por qué entender es un derecho, y no un favor.",
  "Quiénes hacen posible Ye muy fácil.",
];

export default function Podcast() {
  return (
    <section id="podcast" className="py-20 md:py-28 bg-[#14161a] text-[#f6f1e6]">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <SectionHeader
          dark
          eyebrow="Vídeo podcast"
          title="Nos invitaron a La Jungla 501 a contarlo todo."
          text="Un episodio de 24 minutos para entender, en voz de personas, cómo funciona la lectura fácil y para qué sirve."
        />

        <div className="grid lg:grid-cols-[1.25fr_0.75fr] gap-10 mt-14 items-start">
          <Reveal>
            <a
              href={VIDEO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="relative block sketch-2 overflow-hidden bg-black/40 group"
              data-testid="podcast-video-link"
              aria-label="Ver el vídeo podcast de Ye muy fácil en YouTube"
            >
              <img
                src="https://i.ytimg.com/vi/i4ceFizLb-0/maxresdefault.jpg"
                alt="Portada del vídeo podcast de Ye muy fácil en La Jungla 501"
                className="w-full aspect-video object-cover"
                loading="lazy"
              />
              <span className="absolute inset-0 bg-black/25 group-hover:bg-black/5 transition-colors" aria-hidden="true" />
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[var(--yellow)] text-[var(--ink)] shadow-[5px_5px_0_var(--ink)] group-hover:scale-110 transition-transform">
                  <Play className="w-9 h-9 fill-current ml-1" aria-hidden="true" />
                </span>
              </span>
            </a>
            <div className="flex flex-wrap items-center gap-4 mt-6">
              <a
                href={VIDEO_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="podcast-youtube-link"
                className="inline-flex items-center gap-2.5 sketch-sm bg-[#f6f1e6] text-[#131417] px-5 py-3 font-bold hover:-translate-y-0.5 transition-transform"
              >
                <Youtube className="w-5 h-5 text-[#ff0000]" aria-hidden="true" />
                Ver en YouTube
              </a>
              <p className="inline-flex items-center gap-2 text-sm font-bold text-[#c9cfd6]">
                <Clock className="w-4 h-4" aria-hidden="true" />
                Duración: 24 minutos
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="sketch bg-[#1d2026] p-7 md:p-8" data-testid="podcast-points">
              <h3 className="font-display font-bold text-2xl">Lo que vas a escuchar</h3>
              <ol className="mt-6 space-y-5">
                {POINTS.map((p, i) => (
                  <li key={p} className="flex items-start gap-4">
                    <span className="inline-flex items-center justify-center w-9 h-9 shrink-0 sketch-sm bg-[var(--yellow)] text-[var(--ink)] font-display font-extrabold">
                      {i + 1}
                    </span>
                    <p className="text-base md:text-lg leading-relaxed">{p}</p>
                  </li>
                ))}
              </ol>
              <p className="mt-7 font-hand text-2xl text-[var(--yellow)]">«Comunicar de forma clara es un compromiso social.»</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
